import LoadingComponent from 'commons/loading/Loading.component';
import React, { useState, useEffect, useRef } from 'react';
import { getCurrentLangName } from 'helpers/String.helper';
import { formatTimeAgo } from 'helpers/Datetime.helper';
import { getLanguageValue } from 'locales/i18n';
import { PAGE_TYPE } from 'enums';
import { useNavigate, Link } from 'react-router-dom';
import { getAlarmList } from 'api/koach/v2/alarm.api';

const KoachAlarmTooltip = (props: any) => {
    const { onClose } = props;
    const [isInit, setIsInit] = useState(false);
    const [list, setList] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const navigate = useNavigate();
    const tooltipRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const fetchAlarmList = async () => {
            try {
                const data = await getAlarmList(page, limit, true);
                if (data.list) {
                    setList(data.list);
                    setIsInit(true);
                }
            } catch (error) {
                console.error("알림 목록 가져오기 실패:", error);
            }
        };
        fetchAlarmList();
    }, []);

    // 외부 클릭 감지하여 툴팁 닫기
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        // 이벤트 리스너 등록
        document.addEventListener('mousedown', handleClickOutside);

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    return (
        <div 
            ref={tooltipRef}
            className="absolute top-full right-0 mt-2 w-[80%] max-w-[400px] bg-white rounded-lg shadow-xl p-4 border border-gray-100"
        >
            {!isInit ?
                <div className="flex justify-center items-center h-full">
                    <LoadingComponent />
                </div>
                : (
                    <>
                        <div className="space-y-4 overflow-hidden">
                            {list.length === 0 ? (
                                <div className="text-center text-gray-500 py-4">
                                    {getLanguageValue(PAGE_TYPE.KOACH, "alarmTooltip.txtNoAlarm") || "알림이 없습니다."}
                                </div>
                            ) : (
                                list.slice(0, 5).map((alarm: any, index: number) => (
                                    alarm.link ? (
                                        <Link 
                                            key={index} 
                                            to={alarm.link} 
                                            className="flex items-start gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors duration-200"
                                            onClick={onClose}
                                        >
                                            <div className="flex-1 min-w-0">
                                                <p className="text-sm text-gray-800 font-medium leading-snug truncate">
                                                    {getCurrentLangName(alarm.contents)}
                                                </p>
                                                <p className="text-xs text-gray-500 mt-1 truncate">
                                                    {formatTimeAgo(alarm.createdAt)}
                                                </p>
                                            </div>
                                            <div className="flex items-center gap-2 flex-shrink-0">
                                                {!alarm.isRead && (
                                                    <div className="w-2.5 h-2.5 rounded-full bg-red-500"></div>
                                                )}
                                                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                </svg>
                                            </div>
                                        </Link>
                                    ) : (
                                        <div key={index} className="flex items-start gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors duration-200">
                                            <div className="flex-1 min-w-0">
                                                <p className="text-sm text-gray-800 font-medium leading-snug truncate">
                                                    {getCurrentLangName(alarm.contents)}
                                                </p>
                                                <p className="text-xs text-gray-500 mt-1 truncate">
                                                    {formatTimeAgo(alarm.createdAt)}
                                                </p>
                                            </div>
                                            {!alarm.isRead && (
                                                <div className="w-2.5 h-2.5 rounded-full bg-red-500 mt-1 flex-shrink-0"></div>
                                            )}
                                        </div>
                                    )
                                ))
                            )}
                        </div>

                        {list.length > 0 && (
                            <div className="mt-4 pt-4 border-t border-gray-200">
                                <button
                                    onClick={() => {
                                        navigate('/koach/alarm');
                                        onClose();
                                    }}
                                    className="w-full text-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors duration-200 py-1 rounded-md hover:bg-gray-50"
                                >
                                    {getLanguageValue(PAGE_TYPE.KOACH, "alarmTooltip.btnShowAll") || "전체 보기"}
                                </button>
                            </div>
                        )}
                    </>
                )}
        </div>
    );
};

export default KoachAlarmTooltip;